import PTable from './src/table';
// import '@/theme-chalk/src/index.scss'

/* istanbul ignore next */
PTable.install = function (Vue) {
    Vue.component(PTable.name, PTable);
};

export default PTable;
